/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Button as DxButton } from 'devextreme-react/button';
import { DataGrid, SelectBox } from 'devextreme-react';
import {
  Column, Editing, FilterRow, RequiredRule, Scrolling, Sorting,
} from 'devextreme-react/data-grid';
// eslint-disable-next-line no-unused-vars
import React, { useState, useRef } from 'react';
import './device-setup.scss';
import withProps from 'components/bin-plus-tables/withProps';
import CreateDynamicColumn from 'components/wrapped-component/customized-data-grid/CreateDynamicColumn';
import { Alert, Row } from 'react-bootstrap';
import { UtilityFunctions } from 'components/wafer-control-map/utility';
import toast from 'CustomToast';
import commonFunctions from '../../customFunctions';
import getDropDownOptions from 'components/getDropDownOptions';
import ExpressionValueComponent from './expression-value-component';
import EditLevelComponent from './edit-level-component';
import ModalPopup from 'components/wrapped-component/modal-popup/modal-popup';

import { faInfoCircle, faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



type AttributesGridState = {};

type AttributesGridProps = {
  attributes: any,
  allAttributes: any,
  binPlusTables?: any,
  waferControlMaps?: any,
  onAddAttribute: (columnInfo: any, callback: any) => void,
  onAddAttributeDefinition: (data: any) => void,
  onUpdateAttributeDefinition: (data: any) => void,
  onDeleteAttributeDefinition: (id: string) => void,
  overrideAttributeInWC?: boolean,
  workCenterTypes?: any[],
  onDeleteAttribute: (id: string, callback: () => void) => void,
  parentId: string | null,
  needLevel?: boolean,
  needAccess?: boolean,
  needDatatype?: boolean,
  needUDAConstraints?: boolean,
  needUDAAccess?: boolean,
  needUDAType?: boolean,
  passAtrGridRefToParent?: (ref: any) => void,
  masterMetaColumns?: { [entityType: string]: any[] },
};

const DataTypes = {
  STRING: 'string',
  NUMBER: 'number',
  DATE: 'date',
  BOOLEAN: 'boolean',
  BIN_PLUS_TABLE: 'bin plus table',
  WAFER_CONTROL_MAP: 'wafer control map',
};

type FoundryInfoProps = {
  copyToClipboard: (text: string) => Promise<void>;
};

const FoundryInfo: React.FC<FoundryInfoProps> = ({ copyToClipboard }) => {
  const [show, setShow] = useState(false);
  const timeoutRef = useRef<any>(null);

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const fields = ['REFPX', 'REFPY', 'DUTMS', 'XDies', 'YDies'];
  const shiftFields = [
    'Shift X UOM',
    'Shift X',
    'Shift Y UOM',
    'Shift Y',
  ];

  const onEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setShow(true);
  };

  const onLeave = (delayMs = 900) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setShow(false);
      timeoutRef.current = null;
    }, delayMs);
  };

  return (
    <div className="foundry-info-container" onMouseEnter={onEnter} onMouseLeave={() => onLeave(1500)}>
      <span className="foundry-info-label">Recommended attributes for Foundry Step Plan and Shift X/Y</span>
      <button type="button" className="btn btn-link p-0 foundry-info-icon-button" title="Foundry Step Plan Fields">
        <FontAwesomeIcon icon={faInfoCircle} className="foundry-info-icon-size" />
      </button>
      {show && (
        <div className="shadow-sm border rounded bg-white foundry-popover" onMouseEnter={onEnter} onMouseLeave={() => onLeave(900)}>
          <div className="foundry-popover-title">Foundry Step Plan Fields</div>
          <div className="foundry-popover-subtitle">Note: Entity Type must be set to Wafer </div>
          {fields.map((field) => (
            <div key={field} className="d-flex align-items-center justify-content-between foundry-popover-row">
              <span className="foundry-popover-field">{field}</span>
              <button
                type="button"
                className="btn btn-link p-0"
                title="Copy"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  copyToClipboard(field);
                }}
              >
                <FontAwesomeIcon icon={faCopy} />
              </button>
            </div>
          ))}
          <div className="foundry-popover-divider" />
          <div className="foundry-popover-section">
            <div className="foundry-popover-title">Shift X/Y Settings</div>
            {shiftFields.map((field) => (
              <div key={field} className="d-flex align-items-center justify-content-between foundry-popover-row">
                <span className="foundry-popover-field">{field}</span>
                <button
                  type="button"
                  className="btn btn-link p-0"
                  title="Copy"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    copyToClipboard(field);
                  }}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const ACCESS_ITEMS = [
  {
    name: 'Public',
    value: 'PUBLIC',
  },
  {
    name: 'Private',
    value: 'PRIVATE',
  },
];

class AttributesGrid extends React.Component<AttributesGridProps, AttributesGridState> {
  static defaultProps = {
    needLevel: true,
    needAccess: true,
    needDatatype: true,
    needUDAConstraints: true,
    needUDAAccess: true,
    needUDAType: true,
  };

    constructor(props: AttributesGridProps) {
    super(props);
    this.state = {
      // ...existing state...
    };
  }

  handleDeleteRow = (options: any) => {
    const grid = this.datagrid?.instance;
    if (!grid) return;

    const { rowIndex } = options.row;

    if (grid.hasEditData()) {
      const editRowKey = grid.option('editing.editRowKey');
      if (editRowKey === options.key) {
        // Deleting the row that is being edited.
        grid.deleteRow(rowIndex);
        return;
      }

      ModalPopup.confirm({
        header: 'Unsaved Changes',
        body: 'Another row is being edited. Do you want to discard the changes and delete this row?',
      }).then((confirmed) => {
        if (confirmed) {
          // cancelEditData does not return a Promise; call synchronously
          grid.cancelEditData();
          // The grid might re-render and rowIndex could be stale.
          // It's safer to find the row by key.
          const newRowIndex = grid.getRowIndexByKey(options.key);
          if (newRowIndex > -1) {
            grid.deleteRow(newRowIndex);
          }
        }
      });
    } else {
      grid.deleteRow(rowIndex);
    }
  };

  datagrid: DataGrid | null = null;

  foundryPopoverRef: HTMLDivElement | null = null;

  copyToClipboard = async (text: string) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        toast.success('Copied to clipboard!');
        return;
      }
    } catch (err) {
      console.warn('Clipboard API failed, falling back to execCommand', err);
    }

    // Legacy fallback for browsers that do not support the Clipboard API
    // or when clipboard access is denied.
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      toast.success('Copied to clipboard!');
    } finally {
      document.body.removeChild(textArea);
    }
  };

  onValueChanged = (cell: any, e: any) => {
    cell.setValue(e.value);
  };

  clearValue = (colName: string) => {
    const rowIndex = this.datagrid?.instance.getVisibleRows().filter((row: any) => { return row.isEditing; })[0]?.rowIndex;
    const colIndex = this.datagrid?.instance.getVisibleColumns().filter((col: any) => { return col.dataField === colName; })[0]?.visibleIndex;
    // eslint-disable-next-line no-unused-expressions
    if (rowIndex !== undefined && colIndex !== undefined) this.datagrid?.instance.cellValue(rowIndex!, colIndex!, '');
  };

  deleteAttributeAndClearValues = (id: string) => {
    const { onDeleteAttribute, attributes } = this.props;
    
    // Check if attribute is used in saved rows
    const isUsedInSavedRows = attributes.some((attr: any) => attr.name === id);
    
    // Check if attribute is used in unsaved rows (DataGrid)
    let isUsedInUnsavedRows = false;
    if (this.datagrid) {
      const allRows = this.datagrid.instance.getVisibleRows();
      isUsedInUnsavedRows = allRows.some((row: any) => {
        // Check both saved and unsaved rows in the grid
        const rowData = row.data || {};
        return rowData.name === id;
      });
    }
    
    // If attribute is used in any row, show error and don't delete
    if (isUsedInSavedRows || isUsedInUnsavedRows) {
      toast.error('Cannot delete attribute. It is being used in existing attribute definitions.');
      return;
    }
    
    // If not used, proceed with deletion
    onDeleteAttribute(id, () => {
      this.clearValue('name');
      this.clearValue('label');
      this.clearValue('dataType');
    });
  };

  setLabelDataTypeOnNameValue = (newData: any, value: any) => {
    const { allAttributes } = this.props;
    // eslint-disable-next-line no-param-reassign
    newData.name = value;
    const atr = allAttributes.filter((_atr: any) => _atr.id === value)[0];
    // eslint-disable-next-line no-param-reassign
    newData.label = atr?.columnLabel;
    // eslint-disable-next-line no-param-reassign
    newData.dataType = atr?.columnType;
  };

  renderActionsCell = (options: any) => {
    const grid = options.component;
    const isEditingThisRow = options.row.isEditing;
    const isAnyRowEditing = grid.hasEditData();

    return (
      <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
        {isEditingThisRow ? (
          <React.Fragment>
            <DxButton
              stylingMode="text"
              icon="save"
              onClick={() => grid.saveEditData()}
            />
            <DxButton
              stylingMode="text"
              icon="revert"
              onClick={() => grid.cancelEditData()}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <DxButton
              stylingMode="text"
              icon="edit"
              onClick={() => grid.editRow(options.row.rowIndex)}
              disabled={isAnyRowEditing}
            />
            <DxButton
              stylingMode="text"
              icon="trash"
              onClick={() => this.handleDeleteRow(options)}
            />
          </React.Fragment>
        )}
      </div>
    );
  };

  onAddAttribute = (columnInfo: any) => {
    const { onAddAttribute } = this.props;
    onAddAttribute(columnInfo, (atrId: string) => {
      if (this.datagrid === null) return;
      const rows = this.datagrid.instance.getVisibleRows();
      const editRows = rows.filter((row: any) => { return row.isEditing; });
      if (editRows.length > 0 && editRows[0].rowIndex !== undefined) {
        this.datagrid.instance.cellValue(editRows[0].rowIndex, 'name', atrId);
      }
    });
  };

  wrapInDisabledDiv = (value: any) => {
    return (
      <div className="foundry-disabled-cell"
      >
        {value}
      </div>
    );
  };

  editNameCellRender = (cell: any) => {
    const {
      overrideAttributeInWC, workCenterTypes, allAttributes, needUDAType, needUDAConstraints, needUDAAccess,
    } = this.props;
    if (!cell.row.isNewRow) {
      return this.wrapInDisabledDiv(allAttributes.filter((atr: any) => atr.id === cell.value)[0]?.columnName);
    }
    return (
      <Row>
        <div className="edit-name-row">
          <div className="edit-name-left">
            <CreateDynamicColumn
              columnTypes={[
                [DataTypes.STRING, 'Text'],
                [DataTypes.NUMBER, 'Number'],
                [DataTypes.DATE, 'Date'],
                [DataTypes.BOOLEAN, 'Boolean'],
                [DataTypes.BIN_PLUS_TABLE, 'Bin+ Table'],
                [DataTypes.WAFER_CONTROL_MAP, 'Wafer Control Map'],
              ]}
              showEntityTypes
              needUDAType={needUDAType}
              needUDAConstraints={needUDAConstraints}
              needUDAAccess={needUDAAccess}
              needExpression={false}
              overideInWorkCenters={overrideAttributeInWC}
              workCentersList={workCenterTypes}
              getColumnInfo={this.onAddAttribute}
              buttonContent={<small>+ UDA</small>}
            />
          </div>
          <SelectBox
            width="60%"
            defaultValue={cell.value}
            displayExpr="columnName"
            items={allAttributes}
            itemRender={(item) => {
              return (
                <div>
                  <span>{item.columnName}</span>
                  <i
                    className="float-right dx-icon-trash text-danger"
                    onClick={() => { this.deleteAttributeAndClearValues(item.id); }}
                  />
                </div>
              );
            }}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...cell.column.lookup}
            dropDownOptions={getDropDownOptions('cell', cell, [{ minWidth: 200 }])}
            onValueChanged={(event: any) => { this.onValueChanged(cell, event); }}
            valueExpr="id"
          />
        </div>
      </Row>

    );
  };

  editAccessCellRender = (cell: any) => {
    return (
      <SelectBox
        defaultValue={cell.value}
        displayExpr="name"
        items={ACCESS_ITEMS}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...cell.column.lookup}
        onValueChanged={(event) => this.onValueChanged(cell, event)}
        valueExpr="value"
        dropDownOptions={getDropDownOptions('cell', cell)}
      />
    );
  };

  calculateValueFilterExpression = (filterValue: any) => {
    const { binPlusTables, waferControlMaps } = this.props;
    return (data: any) => {
      if (data.value === undefined || data.value === null) return true;
      if (data.dataType === DataTypes.NUMBER) {
        return +filterValue === data.value;
      }
      if (data.dataType === DataTypes.DATE || data.dataType === DataTypes.STRING) {
        return data.value.toString().toLowerCase().includes(filterValue.toLowerCase());
      }
      if (data.dataType === DataTypes.BOOLEAN) {
        return data.value.toString().toLowerCase() === filterValue.toLowerCase();
      }
      if (binPlusTables && data.dataType === DataTypes.BIN_PLUS_TABLE) {
        return binPlusTables.filter((bpt: any) => { return data.value.includes(bpt.id); }).map((bpt: any) => bpt.name).sort().join(' ')
          .includes(filterValue.toLowerCase());
      }
      if (waferControlMaps && data.dataType === DataTypes.WAFER_CONTROL_MAP) {
        return waferControlMaps.filter((wcm: any) => { return data.value.includes(wcm.id); }).map((wcm: any) => wcm.name).sort().join(' ')
          .includes(filterValue.toLowerCase());
      }
      return false;
    };
  };

  calculateNameFilterExpression = (filterValue: any, filterType: any) => {
    const { allAttributes } = this.props;
    return (data: any) => {
      const filteredAtrs = allAttributes.filter((atr: any) => { return atr.id === data.name; });
      if (filteredAtrs.length > 0) {
        return UtilityFunctions.checkFilter(filteredAtrs[0].columnName, filterValue, filterType);
      }
      return false;
    };
  };

  calculateLevelFilterExpression = (filterValue: any) => {
    return (data: any) => {
      return data.level && Object.keys(data.level).join('').toLowerCase().includes(filterValue.toLowerCase());
    };
  };

  // eslint-disable-next-line no-unused-vars
  valueCellRender = (cell: any) => {
    const { binPlusTables, waferControlMaps } = this.props;
    let text = '';
    if (binPlusTables && cell.data.dataType === DataTypes.BIN_PLUS_TABLE) {
      text = binPlusTables.filter((bpt: any) => { return cell.value.includes(bpt.id); }).map((bpt: any) => bpt.name).sort().join(', ');
      return text;
    }
    if (waferControlMaps && cell.data.dataType === DataTypes.WAFER_CONTROL_MAP) {
      text = waferControlMaps.filter((wcm: any) => { return cell.value.includes(wcm.id); }).map((wcm: any) => wcm.name).sort().join(', ');
      return text;
    }
    return cell.value;
  };

  levelCellRender = (cell: any) => {
    // eslint-disable-next-line no-unused-vars
    const text = (Object.entries(cell.value || {}) || []).map(([levelName]: any) => {
      return (<span key={levelName}>{UtilityFunctions.capitalizeFirstLetter(levelName.replace(/_/g, ' ').toLowerCase())}</span>);
    });
    return (
      <div className="level-cell-grid">
        {text}
      </div>
    );
  };

  setAccessCellValue = (newData: any, value: any) => {
    // eslint-disable-next-line no-param-reassign
    newData.access = value;
  };

  onRowInserting = (e: any) => {
    const newRowData = e.data;
    const { attributes, allAttributes } = this.props;
    
    if (commonFunctions.checkDuplicateAttribute(newRowData, attributes, allAttributes, this.datagrid)) {
      e.cancel = true;
      toast.error('An attribute with same name and entity type already exists.');
    }
  };

  render() {
    const {
      attributes, binPlusTables, onAddAttributeDefinition, needAccess, needLevel, needDatatype, allAttributes, masterMetaColumns,
      onUpdateAttributeDefinition, onDeleteAttributeDefinition, parentId, passAtrGridRefToParent, waferControlMaps,
    } = this.props;
    return (

      <>
        <Alert show={parentId === null} variant="warning">
          Save Device Setup To Add Device Settings
        </Alert>
        { parentId !== null && (
          <div className="foundry-info-wrapper">
            <FoundryInfo copyToClipboard={this.copyToClipboard} />
            <DataGrid
            showBorders
            ref={(datagrid) => {
              this.datagrid = datagrid;
              if (passAtrGridRefToParent) passAtrGridRefToParent(datagrid);
            }}
            className="attributes-grid"
            dataSource={attributes}
            hoverStateEnabled
            onToolbarPreparing={(e: any) => {
              if (parentId !== null) {
                e.toolbarOptions.items.unshift({
                  location: 'after',
                  widget: 'dxButton',
                  options: {
                    icon: 'add',
                    onClick: () => {
                      if (this.datagrid) {
                        if (!UtilityFunctions.isDataGridInEditMode(this.datagrid)) {
                          e.component.addRow();
                        } else {
                          toast.warn('Can not add attribute definition. Data grid is in edit mode.');
                        }
                      }
                    },
                    hint: 'Add attribute definition',
                  },
                });
              }
            }}
            height="auto"
            showColumnLines
            allowColumnReordering
            rowAlternationEnabled
            columnResizingMode="widget"
            keyExpr="id"
            onRowRemoved={(event: any) => { onDeleteAttributeDefinition(event.key); }}
            onRowUpdated={(event: any) => { onUpdateAttributeDefinition(event.data); }}
            onRowInserted={(event: any) => { onAddAttributeDefinition(event.data); }}
            onRowInserting={this.onRowInserting}
          >
            <FilterRow visible />
            <Sorting mode="multiple" />
            <Column
              dataField="name"
              minWidth={200}
              setCellValue={this.setLabelDataTypeOnNameValue}
              cellRender={(cell: any) => { return this.wrapInDisabledDiv(allAttributes.filter((atr: any) => atr.id === cell.value)[0]?.columnName); }}
              editCellRender={this.editNameCellRender}
              calculateFilterExpression={this.calculateNameFilterExpression}
            >
              <RequiredRule />
            </Column>
            <Column
              dataField="label"
              width={200}
              allowEditing={false}
              cellRender={(cell: any) => { return this.wrapInDisabledDiv(allAttributes.filter((atr: any) => atr.id === cell.data.name)[0]?.columnLabel || ''); }}
              editCellRender={(cell: any) => { return this.wrapInDisabledDiv(allAttributes.filter((atr: any) => atr.id === cell.data.name)[0]?.columnLabel || ''); }}
            >
              <RequiredRule />
            </Column>
            {needDatatype && (
              <Column
                minWidth={200}
                allowEditing={false}
                dataField="dataType"
                cellRender={(cell: any) => { return this.wrapInDisabledDiv(allAttributes.filter((atr: any) => atr.id === cell.data.name)[0]?.columnType || ''); }}
                editCellRender={(cell: any) => { return this.wrapInDisabledDiv(allAttributes.filter((atr: any) => atr.id === cell.data.name)[0]?.columnType || ''); }}
              >
                <RequiredRule />
              </Column>
            )}
            <Column
              alignment="left"
              minWidth={200}
              dataType="object"
              dataField="value"
              calculateFilterExpression={this.calculateValueFilterExpression}
              cellRender={this.valueCellRender}
              editCellComponent={withProps(ExpressionValueComponent, { binPlusTables, waferControlMaps })}
            >
              <RequiredRule />
            </Column>

            {
              needAccess && (
                <Column
                  width={150}
                  dataField="access"
                  setCellValue={this.setAccessCellValue}
                  editCellRender={this.editAccessCellRender}
                />
              )
            }
            { needLevel && (
              <Column
                width={400}
                minWidth={400}
                dataType="object"
                dataField="level"
                calculateFilterExpression={this.calculateLevelFilterExpression}
                cellRender={this.levelCellRender}
                editCellComponent={withProps(EditLevelComponent, { masterMetaColumns })}
              />
            )}
            <Column
              type="buttons"
              caption="Actions"
              cellRender={this.renderActionsCell}
            />

            <Scrolling mode="virtual" />
            <Editing
              allowUpdating
              confirmDelete={false}
              allowDeleting
              mode="row"
            />
          </DataGrid>
          </div>
        )}
      </>

    );
  }
}

export default AttributesGrid;
